import { sellersWithPhonesSelector } from './sellersSelector';
import { TApplicationState } from 'shared/types/redux';

export function isLeadFactorySelector(state: TApplicationState) {
  return sellersWithPhonesSelector(state).find(seller => seller.isLeadFactory);
}
